import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import IconSelect from "./IconSelect";
import {RichText} from "@wordpress/block-editor";
import PMGColorPalette,{fontColorAssociations} from "./PMGColorPalette";

import {PanelBody,Panel,RangeControl,SelectControl,CheckboxControl,TextControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';



registerBlockType("template-scripts/photo-text-section",{
  "title":"Photo/Text Section",
  "category":"template-scripts",
  "icon":"button",
  attributes:{
    maxWidth:{type:'number',default:1450},
    image:{type:'object',default:{}},
    image2:{type:'object',default:{}},
    backgroundColor:{type:'string',default:'#b65943'},
    backgroundName:{type:'string',default:'teal'},
    reverseColumns:{type:'boolean',default:false},
  },

  edit:function({attributes,setAttributes}){


    return (<div>

      <BlockControls/>
      <InspectorControls>
        <Panel>
          <PanelBody title="Slide Options">
            <CheckboxControl
              label="Reverse Columns"
              checked={attributes.reverseColumns}
              onChange={(v)=>setAttributes({reverseColumns:v})}
            />
            <RangeControl
              label="Max Width"
              min={850}
              max={1850}
              step={10}
              value={attributes.maxWidth}
              onChange={(v)=>setAttributes({maxWidth:v})}
            />
            <MediaUpload
                value={attributes.image}
                onSelect={(v)=>setAttributes({image:v})}
                render={({open})=>(
                  <div className="imageUploadPlaceholder">
                    {attributes.image.url ? <img onClick={open} src={attributes.image.url}/> : <div className="placeholder"></div>}
                    <Button
                      className={`editor-post-featured-image__toggle`}
                      onClick={open}
                      style={{width:"120px"}}
                    >
                      Change Photo 1
                    </Button>
                  </div>
                  )}
            />        
            <MediaUpload
                value={attributes.image2}
                onSelect={(v)=>setAttributes({image2:v})}
                render={({open})=>(
                  <div className="imageUploadPlaceholder">
                    {attributes.image2.url ? <img onClick={open} src={attributes.image2.url}/> : <div className="placeholder"></div>}
                    <Button
                      className={`editor-post-featured-image__toggle`}
                      onClick={open}
                      style={{width:"120px"}}
                    >
                      Change Photo 2
                    </Button>
                  </div>
                  )}
            />        
            <PMGColorPalette
              value={attributes.backgroundColor}
              onChange={(v,colorName)=>{
                setAttributes({backgroundColor:v})
                setAttributes({backgroundName:colorName});
              }}
            />
          </PanelBody>
        </Panel>
      </InspectorControls>
      <div className={`${attributes.backgroundName} photoParagraph ${attributes.reverseColumns ? "reverse" : ""}`} style={{backgroundColor:attributes.backgroundColor}}>
        <div className="container" style={{width:attributes.maxWidth+"px"}}>
          <div className="photos">
            <img src={attributes.image?.url}/>
            <img src={attributes.image2?.url}/>
          </div>
          <div className="text">
            <InnerBlocks
              
            />
          </div>
        </div>
      </div>
    </div>);
  },
  save:function({attributes}){

    return ( <div className={`${attributes.backgroundName} photoParagraph ${attributes.reverseColumns ? "reverse" : ""}`} style={{backgroundColor:attributes.backgroundColor}}>
      <div className="container" style={{width:attributes.maxWidth+"px"}}>
        <div className="photos">
          <img src={attributes.image?.url}/>
          <img src={attributes.image2?.url}/>
        </div>
        <div className="text">
          
          <InnerBlocks.Content/>
        </div>
      </div>
    </div>);
  }
});

